import { FileActionErrorReasonDTO } from '@capture/client-api/src/orval'

import type { Middleware } from '../common/actions'
import { currentUserReducerMapObj } from '../currentUser/reducer'
import { getUsedStorageRatio } from '../currentUser/selectors'
import { FilesCopiedToTimelineFailed } from '../files/actions'
import { FilesRestorationFailed, JobCopiedToTimelineFailed } from '../job/actions'
import {
    AddedMoreFilesThanAvailableStorage,
    FileWasAddedToUploadQueue,
    UploaderFinished,
} from '../uploader/actions'
import { uploaderReducerMapObj } from '../uploader/reducer'
import { getEnquedFiles, isCurrentlyUploading } from '../uploader/selectors'

import { PopupTriggered } from './actions'

export const popupMiddlewareReducerMapObj = {
    ...currentUserReducerMapObj,
    ...uploaderReducerMapObj,
}

type PopupMiddlewareState = StateOfReducerMapObj<typeof popupMiddlewareReducerMapObj>

export const popupMiddleware: Middleware<PopupMiddlewareState> = (store) => {
    let usedQuotaAsUploadStart = 0

    return (next) => (action) => {
        const state = store.getState()

        if (AddedMoreFilesThanAvailableStorage.match(action)) {
            store.dispatch(PopupTriggered('AddedMoreFilesThanAvailableStorage'))
        }

        if (
            FileWasAddedToUploadQueue.match(action) &&
            getEnquedFiles(state).length === 0 &&
            !isCurrentlyUploading(state)
        ) {
            usedQuotaAsUploadStart = getUsedStorageRatio(state)
        }

        if (UploaderFinished.match(action)) {
            if (usedQuotaAsUploadStart < 0.95 && getUsedStorageRatio(state) > 0.95) {
                store.dispatch(PopupTriggered('UsedMoreThan95PercentOfStorage'))
            } else if (usedQuotaAsUploadStart < 0.8 && getUsedStorageRatio(state) > 0.8) {
                store.dispatch(PopupTriggered('UsedMoreThan80PercentOfStorage'))
            }
        }

        if (FilesCopiedToTimelineFailed.match(action) || JobCopiedToTimelineFailed.match(action)) {
            if (action.payload.reason === 'out_of_storage') {
                store.dispatch(PopupTriggered('AddedMoreFilesThanAvailableStorage'))
            }
        }

        if (FilesRestorationFailed.match(action)) {
            if (action.payload.reasons.includes(FileActionErrorReasonDTO.quota_exceeded_error)) {
                store.dispatch(PopupTriggered('RestoredMoreFilesThanAvailableStorage'))
            }
        }

        return next(action)
    }
}
